import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 0;
        padding:0px 8px;
    
    `,
}

ProductCompareCarouselStyles.navigationLink = {
    icon: { iconProps: { src: ChevronLeft } },
    typographyProps: { size: 15 },
    css:css`
        span {
        font-weight: ${TYPOGRAPHY.weight.baseBold} !important;
        }
    `
}